module.exports = __webpack_public_path__ + "media/assets/images/layout/logo_header-1282152c921fd8b7839f58251b241db4.png";